import StorageIcon from '@mui/icons-material/Storage'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import MapIcon from '@mui/icons-material/Map'
import HistorischeDataStadList from './HistorischeDataStadList'
import HistorischeDataGebiedList from './HistorischeDataGebiedList'

const stad = {
  list: HistorischeDataStadList,
  icon: LocationCityIcon,
}

const gebied = {
  list: HistorischeDataGebiedList,
  icon: MapIcon,
}

const groupIcon = StorageIcon

export { stad, gebied, groupIcon }
export default { stad, gebied, groupIcon }
